import { Theme, ThemeOptions, createTheme } from "@material-ui/core/styles";
import {
	CheckBoxOutlineBlankRounded,
	CheckBoxRounded,
	RadioButtonChecked,
	RadioButtonUnchecked
} from "@material-ui/icons";

export const name = "Brage";
export const id = "Brage";

export const muiTheme = (theme: Theme): Theme => {
	const brage: ThemeOptions = {
		props: {
			MuiCheckbox: {
				icon: (
					<CheckBoxOutlineBlankRounded
						style={{ height: theme.spacing(2), width: theme.spacing(2) }}
					/>
				),
				checkedIcon: (
					<CheckBoxRounded
						style={{ height: theme.spacing(2), width: theme.spacing(2) }}
					/>
				)
			},
			MuiRadio: {
				icon: (
					<RadioButtonUnchecked
						style={{ height: theme.spacing(2), width: theme.spacing(2) }}
					/>
				),
				checkedIcon: (
					<RadioButtonChecked
						style={{ height: theme.spacing(2), width: theme.spacing(2) }}
					/>
				)
			},
			MuiAutocomplete: {}
		}
	};

	theme = createTheme(theme, brage);

	const brageOverrides: ThemeOptions = {
		overrides: {
			MuiCssBaseline: {
				"@global": {
					"*": {
						minWidth: "0"
					}
				}
			},
			MuiTypography: {
				h1: {
					color: theme.palette.primary.main
				},
				h2: {
					color: theme.palette.primary.main
				},
				h3: {
					color: theme.palette.primary.main
				},
				h4: {
					color: theme.palette.primary.main
				},
				h5: {
					color: theme.palette.primary.main
				},
				body1: {
					color: theme.palette.accent1.main
				},
				body2: {
					color: theme.palette.accent1.main
				},
				subtitle1: {
					color: theme.palette.accent1.main
				},
				subtitle2: {
					color: theme.palette.accent1.main
				},
				caption: {
					color: theme.palette.accent1.main
				},
				overline: {
					color: theme.palette.accent1.main
				}
			},
			DployFormPanel: {
				root: {
					"&:first-child": {
						marginBottom: theme.spacing(3)
					}
				},
				sectionGroupsContainer: {
					gap: theme.spacing(3)
				}
			},
			DployListField: {},
			DployDirwebFormStyles: {
				mainGrid: {
					padding: "unset",
					paddingTop: 16,
					marginTop: 0,
					[theme.breakpoints.up("md")]: {
						padding: "unset",
						paddingTop: 16,
						marginTop: 0
					}
				},
				titleText: {
					[theme.breakpoints.down("sm")]: {
						margin: "auto 8px"
					},
					fontSize: 30,
					fontWeight: 775,
					lineHeight: "40px"
				}
			},
			DployInput: {
				inputVariantOutline: {
					borderRadius: theme.shape.borderRadius
				},
				selectVariantOutline: {
					borderRadius: theme.shape.borderRadius,
					borderTop: "solid 1px",
					borderRight: "solid 1px",
					borderBottom: "solid 1px",
					borderLeft: "solid 1px"
				}
			},
			DployLockAndEditableSection: {
				editButton: {
					fontSize: "18px",
					lineHeight: "24px",
					padding: 0,
					color: "#8734FF",
					textDecorationLine: "underline",
					textDecorationStyle: "solid",
					textDecorationThickness: 2,
					textDecorationColor: "#8734FF",
					textUnderlineOffset: "6px",
					"&:hover": {
						textDecorationLine: "underline",
						textDecorationStyle: "solid",
						textDecorationThickness: 2,
						textDecorationColor: "#8734FF",
						textUnderlineOffset: "6px"
					}
				}
			},
			DployFormPanelInnerSection: {
				innerSection: {
					margin: theme.spacing(0)
				}
			},
			DployMarkdownElement: {
				root: {
					color: theme.palette.primary.main
				}
			},
			DployFormSection: {
				header: {
					fontSize: 18,
					fontWeight: 775,
					paddingLeft: 0,
					paddingRight: 0,
					marginLeft: "0 !important"
				}
			},
			DployFormFieldContainer: {
				fieldWrapper: {},
				field: {},
				underline: {},
				divider: {
					backgroundColor: theme.palette.common.white
				}
			},
			DployFormLiteral: {
				marginNormal: { padding: "0 !important" },
				suffix: {
					fontWeight: 775
				},
				value: {
					wordBreak: "break-word",
					padding: theme.spacing(1)
				}
			},
			DployFormSectionGroup: {
				expansionSummary: {
					minHeight: "unset"
				},
				expansionLabel: {
					fontSize: 24
				},
				expansionSubTitle: {
					fontSize: 18
				},
				sectionGroup: {
					padding: theme.spacing(3, 2)
				},
				sectionGroupWrapper: {
					padding: 0,
					paddingTop: 0,
					paddingBottom: 0
				}
			},
			DployCalculationField: {
				root: {
					gap: theme.spacing(1)
				},
				searchButtonContainer: {
					height: "56px",
					marginTop: 0
				},
				searchButton: {
					height: "100%",
					backgroundColor: theme.palette.common.white
				}
			},
			DploySelectionField: {
				radioControlLabel: {},
				formGroup: { paddingBottom: 0 },
				buttonGroup: {
					border: "1px solid",
					borderColor: theme.palette.accent1.main
				},
				toggleButtonGroup: {
					textTransform: "none",
					color: theme.palette.primary.main,
					"&.Mui-selected": {
						color: "white",
						backgroundColor: theme.palette.primary.main
					}
				},
				toggleButtonSwitch: {
					color: "#8734FF",
					backgroundColor: "transparent",
					textTransform: "none",
					textDecorationLine: "underline",
					textDecorationStyle: "solid",
					textDecorationThickness: 2,
					textDecorationColor: "#8734FF",
					textUnderlineOffset: "6px",
					"&:hover": {
						textDecorationLine: "underline",
						textDecorationStyle: "solid",
						textDecorationThickness: 2,
						textDecorationColor: "#8734FF",
						textUnderlineOffset: "6px"
					},
					"&$selected": {
						color: "#8734FF"
					},
					"&:not(:first-child)": {
						border: "unset"
					}
				}
			},
			CheckboxField: {
				root: {},
				formControlLabel: {
					backgroundColor: "unset",
					borderStyle: "none",
					alignItems: "start",
					width: 550,
					padding: theme.spacing(0),
					marginLeft: -theme.spacing(2) // Counteract accordion padding
				}
			},
			MuiPaper: {
				root: {
					backgroundColor: theme.palette.accent2.main
				}
			},
			MuiFormControlLabel: {
				root: {
					boxSizing: "border-box",
					borderWidth: 1,
					borderStyle: "solid",
					borderRadius: theme.shape.borderRadius,
					borderColor: theme.palette.accent1.main,
					padding: theme.spacing(0, 2),
					gap: theme.spacing(2),
					minHeight: 56,
					fontSize: 18,
					marginLeft: "unset",
					marginRight: "unset",
					backgroundColor: theme.palette.common.white,
					"&:has( > .Mui-checked)": {
						borderWidth: 2
					}
				},
				label: {
					padding: "unset"
				}
			},
			MuiFormGroup: {
				root: {
					gap: theme.spacing(1)
				}
			},
			MuiRadio: {
				root: {
					color: theme.palette.primary.main,
					padding: theme.spacing(0),
					"&$checked": {
						color: theme.palette.primary.main
					}
				},
				colorSecondary: {
					"&$checked": {
						color: theme.palette.primary.main
					}
				}
			},
			MuiCheckbox: {
				root: { padding: 0 }
			},
			MuiFormLabel: {
				root: {
					color: theme.palette.accent1.main
				}
			},
			MuiOutlinedInput: {
				root: {
					borderRadius: theme.shape.borderRadius,
					backgroundColor: theme.palette.common.white
				},
				inputMultiline: {
					padding: "10px"
				}
			},
			MuiInputLabel: {},
			MuiFormHelperText: {},
			MuiInputBase: {},
			MuiAutocomplete: {
				listbox: {
					backgroundColor: theme.palette.common.white
				}
			},
			MuiButton: {
				root: {
					borderRadius: 136,
					padding: theme.spacing(2, 4),
					textTransform: "none"
				},
				label: {
					fontSize: "1rem",
					padding: 0
				},
				containedSizeLarge: {
					padding: theme.spacing(2, 4),
					borderStyle: "solid",
					borderWidth: 2,
					borderColor: theme.palette.primary.main,
					minHeight: 56
				},
				text: {
					textDecorationLine: "underline",
					textDecorationStyle: "solid",
					textDecorationThickness: 2,
					textDecorationColor: theme.palette.accent3.main,
					textUnderlineOffset: "6px",
					"&:hover": {
						textDecorationLine: "underline",
						textDecorationStyle: "solid",
						textDecorationThickness: 2,
						textDecorationColor: theme.palette.accent3.main,
						textUnderlineOffset: "6px"
					}
				},
				textSecondary: {
					color: theme.palette.accent3.main,
					padding: theme.spacing(2, 4),
					"& $label": {
						textDecorationColor: theme.palette.accent3.main
					}
				},
				textSizeLarge: {
					padding: theme.spacing(2, 4),
					minHeight: 56
				},
				endIcon: {
					marginLeft: theme.spacing(1),
					marginRight: theme.spacing(-1)
				},
				startIcon: {
					marginLeft: theme.spacing(-1),
					marginRight: theme.spacing(1)
				}
			},

			MuiDivider: {},
			MuiAccordion: {
				root: {
					maxWidth: 550,
					marginLeft: "auto",
					marginRight: "auto",
					"&:before": {
						opacity: 0
					},
					"&$expanded": {
						marginTop: "unset",
						marginLeft: "auto",
						marginRight: "auto"
					}
				},
				expanded: {},
				rounded: {
					borderRadius: theme.shape.borderRadius,
					padding: theme.spacing(3, 2)
				}
			},
			MuiSvgIcon: {
				root: {
					color: theme.palette.primary.main
				}
			},
			MuiAccordionSummary: {
				root: {
					padding: 0,
					margin: "unset",
					marginTop: 0,
					marginBottom: 0,
					"&$expanded": {
						marginTop: 0,
						marginBottom: 0
					}
				},
				expandIcon: {
					margin: "auto"
				},
				content: {
					marginTop: 0,
					marginBottom: 0,
					"&$expanded": {
						marginTop: 0,
						marginBottom: 0
					}
				}
			},
			MuiAccordionDetails: {}
		}
	};

	return createTheme(theme, brageOverrides);
};
